import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';

import { Alert, AlertType } from '../_models/alert';

@Injectable()
export class AlertService {
    private subject = new Subject<Alert>();
    private keepAfterRouteChange = false;

    constructor(private router: Router) {
        // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (this.keepAfterRouteChange) {
                    // only keep for a single route change
                    this.keepAfterRouteChange = false;
                } else {
                    // clear alert messages
                    this.clear();
                }
            }
        });
    }

    getAlert(): Observable<any> {
        return this.subject.asObservable();
    }

    success(message: string, customData = '', viewRef = null, keepAfterRouteChange = false) {
        this.alert(AlertType.Success, message, customData, viewRef, keepAfterRouteChange);
    }

    error(message: string, customData = '', viewRef = null, keepAfterRouteChange = false) {
        this.alert(AlertType.Error, message, customData, viewRef, keepAfterRouteChange);
    }

    info(message: string, customData = '', viewRef = null, keepAfterRouteChange = false) {
        this.alert(AlertType.Info, message, customData, viewRef, keepAfterRouteChange);
    }

    warn(message: string, customData = '', viewRef = null, keepAfterRouteChange = false) {
        this.alert(AlertType.Warning, message, customData, viewRef, keepAfterRouteChange);
    }

    alert(type: AlertType, message: string, customData = '', viewRef = null, keepAfterRouteChange = false) {
        this.keepAfterRouteChange = keepAfterRouteChange;
        this.subject.next(<Alert>{ type: type, message: message, customData: customData, viewRef: viewRef });
    }

    clear() {
        // clear alerts
        this.subject.next();
    }
}


// WEBPACK FOOTER //
// ./src/app/exa/_services/alert.service.ts